import { useState, useEffect } from "react";
import {
  BarChart3,
  Briefcase,
  ChevronRight,
  ClipboardList,
  GitCommitVertical,
  LayoutDashboard,
  ListOrdered,
  Receipt,
  Settings,
  User2,
  UserRoundCog,
  LineChart,
  DollarSign,
  LandmarkIcon,
  PiggyBank,
  Banknote,
  Award,
  ShoppingCart,
  Factory,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../store/reducers/sidebarSlice";
import { NavLink, useLocation } from "react-router-dom";
import { Permissions } from "../../permissions";

const Sidebar = () => {
  const sidebar = useSelector(state => state.sidebar);
  const dispatch = useDispatch();
  const location = useLocation();

  // State to track what's selected
  const [activeMainMenu, setActiveMainMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [openNestedSubMenuId, setOpenNestedSubMenuId] = useState(null);

  const handleMenuClick = menu => {
    if (!sidebar.expand) {
      dispatch(expandSidebar());
    }

    // Special handling for Dashboard - collapse any open submenu
    if (menu.id === 0) {
      setOpenSubMenuId(null);
      localStorage.removeItem("openSubMenu");
      setActiveMainMenu(menu.id);
      setActiveSubMenu(null);
      return;
    }

    // For items with submenus, toggle them
    if (menu.sublist.length > 0) {
      if (openSubMenuId === menu.id) {
        setOpenSubMenuId(null);
        localStorage.removeItem("openSubMenu");
      } else {
        setOpenSubMenuId(menu.id);
        localStorage.setItem("openSubMenu", menu.id.toString());

        // Select the first submenu item by default
        if (menu.sublist.length > 0) {
          setActiveMainMenu(menu.id);
          setActiveSubMenu(menu.sublist[0].id);
        }
      }
    } else {
      setActiveMainMenu(menu.id);
      setActiveSubMenu(null);
    }
  };

  const handleSubMenuClick = (mainMenu, subMenu) => {
    setActiveMainMenu(mainMenu.id);
    setActiveSubMenu(subMenu.id);

    if (subMenu.sublist?.length > 0) {
      setOpenNestedSubMenuId(
        openNestedSubMenuId === subMenu.id ? null : subMenu.id,
      );
    }
  };

  let showPoster =
    Permissions.find(permission => permission.includes("show_poster")) !==
    undefined;

  let createcommonvoucher =
    Permissions.find(permission =>
      permission.includes("create_commonVouchers"),
    ) !== undefined;

  let createuservoucher =
    Permissions.find(permission =>
      permission.includes("create_userVouchers"),
    ) !== undefined;

  let showEmployee =
    Permissions.find(permission => permission.includes("show_employee")) !==
    undefined;

  let showRole =
    Permissions.find(permission => permission.includes("show_role")) !==
    undefined;

  let show_outstandingBalances =
    Permissions.find(permission =>
      permission.includes("show_outstandingBalances"),
    ) !== undefined;

  let show_Ledger =
    Permissions.find(permission => permission.includes("show_ledger")) !==
    undefined;

  let show_gstreport =
    Permissions.find(permission => permission.includes("show_gstReports")) !==
    undefined;

  let show_receipt =
    Permissions.find(permission => permission.includes("show_receipts")) !==
    undefined;

  let create_receipt =
    Permissions.find(permission => permission.includes("create_receipts")) !==
    undefined;

  let show_customer =
    Permissions.find(permission => permission.includes("show_customer")) !==
    undefined;

  let create_customer =
    Permissions.find(permission => permission.includes("create_customer")) !==
    undefined;

  let show_location =
    Permissions.find(permission => permission.includes("show_location")) !==
    undefined;

  // Add permissions for finance module (can be configured later)
  let show_purchases = true;
  let show_salaries = true;
  let show_expenses = true;

  // Add permissions for loyalty module (can be configured later)
  let show_loyalty_points = true;
  let show_points_history = true;
  let show_redemption_rules = true;

  const Menus = [
    {
      id: 0,
      title: "Dashboard",
      src: LayoutDashboard,
      sublist: [],
      Navigation: "/",
    },
    {
      id: 1,
      title: "Listing",
      src: Briefcase,
      Navigation: "/products",
      sublist: [
        {
          id: 0,
          title: "Products",
          Icon: GitCommitVertical,
          Navigation: "/products",
        },
        {
          id: 1,
          title: "Unit",
          Icon: GitCommitVertical,
          Navigation: "/products/units",
        },
        {
          id: 2,
          title: "Category",
          Icon: GitCommitVertical,
          Navigation: "/products/category",
        },
        {
          id: 3,
          title: "Brands",
          Icon: GitCommitVertical,
          Navigation: "/products/brands",
        },
      ],
    },
    {
      id: 2,
      title: "Order",
      src: ListOrdered,
      Navigation: "/orders",
      sublist: [
        {
          id: 0,
          title: "Order",
          Icon: GitCommitVertical,
          Navigation: "/orders",
        },
        {
          id: 1,
          title: "Create Order",
          Icon: GitCommitVertical,
          Navigation: "/orders/createOrder",
        },
      ],
    },
    {
      id: 3,
      title: "Customer",
      src: User2,
      Navigation: "/customer/viewcustomer",
      sublist: [
        ...(show_customer
          ? [
              {
                id: 0,
                title: "View Customer",
                Icon: GitCommitVertical,
                Navigation: "/customer/viewcustomer",
              },
            ]
          : []),

        ...(create_customer
          ? [
              {
                id: 1,
                title: "Add Customers",
                Icon: GitCommitVertical,
                Navigation: "/customer/addcustomer",
              },
            ]
          : []),

        {
          id: 2,
          title: "Customer Requests",
          Icon: GitCommitVertical,
          Navigation: "/customer/request",
        },
        // ...(show_location
        //   ? [
        //       {
        //         id: 3,
        //         title: "Location",
        //         Icon: GitCommitVertical,
        //         Navigation: "/customer/location",
        //       },
        //     ]
        //   : []),
      ],
    },
    {
      id: 4,
      title: "Receipts",
      src: ClipboardList,
      Navigation: "/receipt",
      sublist: [
        ...(show_receipt
          ? [
              {
                id: 0,
                title: "View Receipts",
                Icon: GitCommitVertical,
                Navigation: "/receipt",
              },
            ]
          : []),
        ...(create_receipt
          ? [
              {
                id: 1,
                title: "Add Receipts",
                Icon: GitCommitVertical,
                Navigation: "/receipt/addreceipt",
              },
            ]
          : []),
      ],
    },
    {
      id: 5,
      title: "Voucher",
      src: Receipt,
      Navigation: "/voucher",
      sublist: [
        ...(createcommonvoucher || createuservoucher
          ? [
              {
                id: 0,
                title: "Add Voucher",
                Icon: GitCommitVertical,
                Navigation: "/voucher",
              },
            ]
          : []),

        {
          id: 1,
          title: "View Voucher",
          Icon: GitCommitVertical,
          Navigation: "/voucher/viewvoucher",
        },

        ...(showPoster
          ? [
              {
                id: 2,
                title: "Poster",
                Icon: GitCommitVertical,
                Navigation: "/voucher/poster",
              },
            ]
          : []),
      ],
    },
    {
      id: 6,
      title: "Reports",
      src: BarChart3,
      Navigation: "/report/outstanding-balance",
      sublist: [
        ...(show_outstandingBalances
          ? [
              {
                id: 0,
                title: "Outstanding Balance",
                Icon: GitCommitVertical,
                Navigation: "/report/outstanding-balance",
                sublist: [
                  {
                    id: 0,
                    title: "All",
                    Icon: GitCommitVertical,
                    Navigation: "/report/outstanding-balance",
                  },
                  {
                    id: 1,
                    title: "Particular User",
                    Icon: GitCommitVertical,
                    Navigation: "/report/particularUser",
                  },
                ],
              },
            ]
          : []),

        ...(show_Ledger
          ? [
              {
                id: 1,
                title: "Ledger",
                Icon: GitCommitVertical,
                Navigation: "/report/ledger",
              },
            ]
          : []),

        ...(show_gstreport
          ? [
              {
                id: 2,
                title: "GST Reports",
                Icon: GitCommitVertical,
                Navigation: "/report/gstreport",
              },
            ]
          : []),
      ],
    },
    {
      id: 7,
      title: "Purchase",
      src: ShoppingCart,
      Navigation: "/purchase/orders",
      sublist: [
        {
          id: 0,
          title: "Purchase Orders",
          Icon: GitCommitVertical,
          Navigation: "/purchase/orders",
        },
        {
          id: 1,
          title: "Purchase Inward",
          Icon: GitCommitVertical,
          Navigation: "/purchase/inward",
        },
        {
          id: 2,
          title: "Purchase Return",
          Icon: GitCommitVertical,
          Navigation: "/purchase/return",
        },
      ],
    },
    {
      id: 8,
      title: "Production",
      src: Factory,
      Navigation: "/production/jobslips",
      sublist: [
        {
          id: 0,
          title: "Job Slips",
          Icon: GitCommitVertical,
          Navigation: "/production/jobslips",
        },
        {
          id: 1,
          title: "Design Recipe",
          Icon: GitCommitVertical,
          Navigation: "/production/design-recipe",
        },
        {
          id: 2,
          title: "Karigar",
          Icon: GitCommitVertical,
          Navigation: "/production/karigar",
        },
        {
          id: 3,
          title: "Material",
          Icon: GitCommitVertical,
          Navigation: "/production/materials",
        },
      ],
    },
    {
      id: 9,
      title: "Finance",
      src: Banknote,
      Navigation: "/finance/purchases",
      sublist: [
        ...(show_purchases
          ? [
              {
                id: 0,
                title: "Purchases",
                Icon: GitCommitVertical,
                Navigation: "/finance/purchases",
              },
            ]
          : []),
        ...(show_salaries
          ? [
              {
                id: 1,
                title: "Salaries",
                Icon: GitCommitVertical,
                Navigation: "/finance/salaries",
              },
            ]
          : []),
        ...(show_expenses
          ? [
              {
                id: 2,
                title: "Expenses",
                Icon: GitCommitVertical,
                Navigation: "/finance/expenses",
              },
            ]
          : []),
      ],
    },
    {
      id: 10,
      title: "Loyalty Program",
      src: Award,
      Navigation: "/loyalty",
      sublist: [
        ...(show_loyalty_points
          ? [
              {
                id: 0,
                title: "Manage Points",
                Icon: GitCommitVertical,
                Navigation: "/loyalty",
              },
            ]
          : []),
        ...(show_points_history
          ? [
              {
                id: 1,
                title: "Transaction History",
                Icon: GitCommitVertical,
                Navigation: "/loyalty/history",
              },
            ]
          : []),
        ...(show_redemption_rules
          ? [
              {
                id: 2,
                title: "Redemption Rules",
                Icon: GitCommitVertical,
                Navigation: "/loyalty/redemption",
              },
            ]
          : []),
      ],
    },
    {
      id: 11,
      title: "User Management",
      src: UserRoundCog,
      Navigation: "/usermanagement",
      sublist: [
        ...(showEmployee
          ? [
              {
                id: 0,
                title: "User",
                Icon: GitCommitVertical,
                Navigation: "/usermanagement",
              },
            ]
          : []),
        ...(showRole
          ? [
              {
                id: 1,
                title: "Role",
                Icon: GitCommitVertical,
                Navigation: "/usermanagement/roles",
              },
            ]
          : []),
      ],
    },
    {
      id: 12,
      title: "Settings",
      src: Settings,
      sublist: [],
      Navigation: "/settings",
    },
  ];

  const getInitialOpenMenu = () => {
    const savedOpenMenu = localStorage.getItem("openSubMenu");
    if (savedOpenMenu) {
      return parseInt(savedOpenMenu);
    }
    const currentMenu = Menus.find(menu =>
      menu.sublist.some(
        item =>
          item.Navigation === location.pathname ||
          item.sublist?.some(
            subItem => subItem.Navigation === location.pathname,
          ),
      ),
    );
    return currentMenu?.id ?? null;
  };
  const [openSubMenuId, setOpenSubMenuId] = useState(getInitialOpenMenu());

  useEffect(() => {
    if (openSubMenuId !== null) {
      localStorage.setItem("openSubMenu", openSubMenuId.toString());
    } else {
      localStorage.removeItem("openSubMenu");
    }
  }, [openSubMenuId]);

  useEffect(() => {
    // Special handling for root path (Dashboard)
    if (location.pathname === "/") {
      const dashboardMenu = Menus.find(menu => menu.Navigation === "/");
      if (dashboardMenu) {
        setActiveMainMenu(dashboardMenu.id);
        setActiveSubMenu(null);
        setOpenSubMenuId(null); // Close any open submenu
        return;
      }
    }

    // Find the main menu that contains the current path as exact match
    for (const menu of Menus) {
      if (menu.Navigation === location.pathname) {
        setActiveMainMenu(menu.id);
        setActiveSubMenu(null);

        // If this menu has submenus, open the submenu
        if (menu.sublist.length > 0) {
          setOpenSubMenuId(menu.id);
        } else {
          setOpenSubMenuId(null);
        }
        return;
      }
    }

    // Check for submenu exact matches
    for (const menu of Menus) {
      const matchingSubmenu = menu.sublist.find(
        item => item.Navigation === location.pathname,
      );

      if (matchingSubmenu) {
        setActiveMainMenu(menu.id);
        setActiveSubMenu(matchingSubmenu.id);
        setOpenSubMenuId(menu.id);
        return;
      }

      // Check for nested submenu matches
      for (const subItem of menu.sublist) {
        if (subItem.sublist) {
          const nestedMatch = subItem.sublist.find(
            nestedItem => nestedItem.Navigation === location.pathname,
          );

          if (nestedMatch) {
            setActiveMainMenu(menu.id);
            setActiveSubMenu(subItem.id);
            setOpenSubMenuId(menu.id);
            setOpenNestedSubMenuId(subItem.id);
            return;
          }
        }
      }
    }
  }, [location.pathname]);

  return (
    <div className="h-screen sticky top-0 flex-none">
      <div
        className={`${
          sidebar.expand ? "w-[18.055555vw]" : "w-[5vw]"
        } bg-[#f5f3fd] h-screen overflow-y-auto overflow-x-hidden duration-300`}>
        <ChevronRight
          className={`absolute cursor-pointer rotate-0 -right-3 top-9 w-[2.083333vw] shadow-md ring-black bg-white
           border-2 rounded-full ${sidebar.expand && "rotate-180"}`}
          onClick={() => {
            if (sidebar.expand) dispatch(collapseSidebar());
            else dispatch(expandSidebar());
          }}
        />
        <div className="flex">
          <div
            className={`flex flex-col mt-[3.055555vh] mx-[2.63888vw] duration-300 ${
              !sidebar.expand && "scale-0"
            }`}>
            <h1 className="text-[20px] font-poppins font-bold text-[#5652B0] tracking-tight">
              SR Creations
            </h1>
            <div className="flex items-center mt-[4px]">
              <div className="h-[2px] w-[40px] bg-[#5652B0]"></div>
              <div className="h-[2px] w-full bg-gray-200 ml-[2px]"></div>
            </div>
          </div>
        </div>
        <ul className="mt-[1.94444vh] ml-[1.527777vw] flex flex-col">
          {Menus.map(Menu => (
            <div key={Menu.id}>
              {Menu.id === 10 || Menu.id === 0 ? (
                <NavLink
                  to={Menu.Navigation}
                  className={({ isActive }) => (isActive ? "active-menu" : "")}>
                  <div
                    className={`flex items-center justify-center rounded-md cursor-pointer hover:bg-[#EAD8FC] w-[97%] text-gray-300 text-sm gap-x-4 pt-[1.203703704vh] pb-[1.203703704vh] ${
                      sidebar.expand && "pl-[1.805555vw] pr-[1.1111111vw]"
                    } ${sidebar.expand ? "w-[16.9675vw]" : "w-[3vw] ml-[0.4vw]"}
                ${Menu.gap ? "mt-9" : "mt-2"} ${
                      activeMainMenu === Menu.id && "bg-light-white"
                    }`}
                    onClick={() => handleMenuClick(Menu)}>
                    <Menu.src
                      color={activeMainMenu === Menu.id ? "#5652B0" : "#000"}
                      className={`${
                        sidebar.expand
                          ? "w-[1.52777vw] h-[1.527777vw]"
                          : "w-[2.92777vw]"
                      }`}
                    />
                    <span
                      className={`${!sidebar.expand && "hidden"} ${
                        activeMainMenu === Menu.id
                          ? "text-[#5652B0]"
                          : "text-[#000]"
                      } origin-left duration-200 text-[16px] whitespace-nowrap w-[50%] flex items-start justify-start`}>
                      {Menu.title}
                    </span>
                    <div className="w-[50%] flex items-center justify-center h-full">
                      <ChevronRight
                        alt="Opening arrow"
                        className={`${
                          openSubMenuId === Menu.id && "transform rotate-90"
                        } ${!sidebar.expand && "hidden"} ${
                          Menu.sublist.length === 0 && "hidden"
                        } duration-200 h-[2.448vh] aspect-auto`}
                        color={`${
                          activeMainMenu !== Menu.id ? "#000" : "#5652B0"
                        }`}
                      />
                    </div>
                  </div>
                </NavLink>
              ) : (
                <NavLink
                  to={Menu.Navigation}
                  className={({ isActive }) => {
                    // Only consider exact matches for main menu
                    return isActive && Menu.Navigation === location.pathname
                      ? "active-menu"
                      : "";
                  }}>
                  <div
                    className={`flex items-center justify-center rounded-md cursor-pointer hover:bg-[#EAD8FC] w-[97%] text-gray-300 text-sm gap-x-4 pt-[1.203703704vh] pb-[1.203703704vh] ${
                      sidebar.expand && "pl-[1.805555vw] pr-[1.1111111vw]"
                    } ${sidebar.expand ? "w-[16.9675vw]" : "w-[3vw] ml-[0.4vw]"}
                  ${Menu.gap ? "mt-9" : "mt-2"} ${
                      activeMainMenu === Menu.id && "bg-light-white"
                    }`}
                    onClick={() => handleMenuClick(Menu)}>
                    <Menu.src
                      color={activeMainMenu === Menu.id ? "#5652B0" : "#000"}
                      className={`${
                        sidebar.expand
                          ? "w-[1.52777vw] h-[1.527777vw]"
                          : "w-[2.92777vw]"
                      }`}
                    />
                    <span
                      className={`${!sidebar.expand && "hidden"} ${
                        activeMainMenu === Menu.id
                          ? "text-[#5652B0]"
                          : "text-[#000]"
                      } origin-left duration-200 text-[16px] whitespace-nowrap w-[50%] flex items-start justify-start`}>
                      {Menu.title}
                    </span>
                    <div className="w-[50%] flex items-center justify-center h-full">
                      <ChevronRight
                        alt="Opening arrow"
                        className={`${
                          openSubMenuId === Menu.id && "transform rotate-90"
                        } ${!sidebar.expand && "hidden"} ${
                          Menu.sublist.length === 0 && "hidden"
                        } duration-200 h-[2.448vh] aspect-auto`}
                        color={`${
                          activeMainMenu !== Menu.id ? "#000" : "#5652B0"
                        }`}
                      />
                    </div>
                  </div>
                </NavLink>
              )}
              {openSubMenuId === Menu.id && Menu.sublist.length > 0 && (
                <ul className="w-[13.3333vw] ml-[0.2222vw] flex items-center justify-center flex-col">
                  {Menu.sublist.map(subMenu => (
                    <div key={subMenu.id}>
                      <NavLink
                        to={subMenu.Navigation}
                        className={({ isActive }) =>
                          `${!sidebar.expand && "hidden"} ${
                            isActive ? "submenu-active" : ""
                          }`
                        }>
                        <li
                          className={`flex items-center justify-start rounded-md cursor-pointer hover:bg-white text-gray-300 text-sm py-1 gap-x-4 pl-[0.8333333vw] pr-[0.83333333vw] w-[12.94vw] ml-[2.688888vw] ${
                            activeSubMenu === subMenu.id && "bg-light-white"
                          }`}
                          onClick={() => handleSubMenuClick(Menu, subMenu)}>
                          <div
                            className={`w-[8px] h-[8px] rounded-full ${
                              activeSubMenu === subMenu.id ||
                              location.pathname === subMenu.Navigation
                                ? "bg-purple-600"
                                : "bg-[#acacac]"
                            }`}></div>
                          <span
                            className={`${!sidebar.expand && "hidden"} ${
                              activeSubMenu === subMenu.id ||
                              location.pathname === subMenu.Navigation
                                ? "text-[#5652B0]"
                                : "text-[#000]"
                            } origin-left duration-200 text-[14px] font-normal whitespace-nowrap`}>
                            {subMenu.title}
                          </span>
                        </li>
                        {subMenu.id < Menu.sublist.length - 1 && (
                          <div className=" w-[50%] h-[1.3vh] flex items-center justify-start">
                            <div className="border border-[#acacac] border-l-1 h-[2.866666vh] my-1 w-0 ml-[3.7255vw]"></div>
                          </div>
                        )}
                      </NavLink>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
